/**
 * Whether the inline subtask input should render after this flat-list row.
 * Defers past the parent's contiguous descendants so the input appears after
 * the last child/descendant, not immediately under the parent.
 *
 * @param {import('@/types').Task} task
 * @param {number} index
 * @param {import('@/types').Task[]} tasks
 * @param {string | null | undefined} addingSubtaskTo
 * @param {Map<string, import('@/types').Task>} [tasksMap]
 * @returns {boolean}
 */
const MAX_ANCESTOR_WALK_DEPTH = 20;

export function shouldShowSubtaskInputAfter(
  task,
  index,
  tasks,
  addingSubtaskTo,
  tasksMap = new Map(),
) {
  if (!addingSubtaskTo) return false;

  const isUnderParent = (candidate) => {
    if (!candidate) return false;
    if (candidate.id === addingSubtaskTo) return true;
    let currentId = candidate.parentId;
    let depth = 0;
    while (currentId && depth < MAX_ANCESTOR_WALK_DEPTH) {
      if (currentId === addingSubtaskTo) return true;
      currentId = tasksMap.get(currentId)?.parentId ?? null;
      depth += 1;
    }
    return candidate.parentId === addingSubtaskTo;
  };

  if (!isUnderParent(task)) return false;
  const next = tasks[index + 1];
  return !isUnderParent(next);
}
